module.exports = __webpack_public_path__ + "img/plane_track_mobile_2.79d3a8bb.svg";